export class Version {
  adminAPIVersion = '0.0.0';
  clockVersion = '0.0.0';
  adminUIVersion = '0.0.0';
  clockServiceVersion = '0.0.0';
  audioServiceVersion = '0.0.0';
  clockEngineVersion = '0.0.0';
}
